import { Box, Button, Typography } from "@mui/material";

import { GoogleLogin } from "@react-oauth/google";

const ConnectGoogleAccount = ({
  handleConnectToGoogle,
  handleSkinConnectToGoogle,
  handleFailure
}: {
  handleConnectToGoogle: () => void;
  handleSkinConnectToGoogle: () => void;
  handleFailure: () => void;
}) => {
  return (
    <Box
      bgcolor={"white"}
      padding={4}
      borderRadius={1.5}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={2}
      width={"408px"}
    >
      <Box height={"48px"} width={"48px"}>
        <img
          src={"/icons/google.png"}
          alt="google"
          width={"100%"}
          height={"100%"}
        />
      </Box>
      <Box textAlign={"center"} marginTop={2} marginBottom={3}>
        <Typography variant="h4" color="text.primary">
          Link Google Accounts
        </Typography>
        <Typography variant="body2" color="text.primary" marginTop={1}>
          Link your Google accounts to unlock detailed insights from Google
          Analytics 4 and Google Search Console.{" "}
        </Typography>
      </Box>
      <Box width={"100%"}>
         <GoogleLogin onSuccess={handleConnectToGoogle} onError={handleFailure} />

        <Button
          sx={{
            textDecoration: "underline",
            color: "#00000099 !important",
            marginTop: "12px",
          }}
          variant="text"
          fullWidth
          onClick={handleSkinConnectToGoogle}
          size="large"
        >
          Skip for now
        </Button>
      </Box>
    </Box>
  );
};

export default ConnectGoogleAccount;
